export const getImageListSummaryDetailsStyles = () => ({
  container: {
    display: 'flex',
    gap: '6px',
  },
  thumbnail: {
    width: '48px',
    height: '36px',
    borderRadius: '4px',
  },
});
